import { render, staticRenderFns } from "./JalMileExchange.vue?vue&type=template&id=87975cf8&"
import script from "./JalMileExchange.vue?vue&type=script&lang=ts&"
export * from "./JalMileExchange.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports